<script setup>
import { useAppStore } from '@/stores/App'
import { useDisplay } from 'vuetify'

// mobile breakpoint
const { xs, smAndDown } = useDisplay()

// Vars
const app = useAppStore()
const staticURLImg = useRuntimeConfig().public.staticURLImg
</script>

<template>
    <v-row id="thetestimonials" class="st-bg-gradient-yellow-anim justify-center slide-from-left">
        <!-- <v-col cols="10" class="text-h2 text-center font-weight-medium"> Our Clients </v-col> -->
        <v-col cols="10">
            <v-row class="justify-center">
                <v-col cols="12" sm="10" class="text-center bg-transparent">
                    <v-hover>
                        <template v-slot:default="{ isHovering, props }">
                            <v-carousel
                                v-bind="props"
                                id="testimonialscarousel"
                                :cycle="isHovering ? false : true"
                                hide-controls
                                hide-delimiters
                                hide-delimiter-background
                                show-arrows="hover"
                                delimiter-icon="mdi-rhombus"
                                color="primary"
                                interval="9000"
                                :height="xs ? 640 : 580"
                                class="rounded"
                            >
                                <v-carousel-item v-for="tm in app.testimonials" :key="tm.person">
                                    <v-sheet height="100%" class="py-4 bg-transparent">
                                        <div class="d-flex flex-column fill-height justify-center align-center">
                                            <div
                                                class="mt-16 py-4 text-h6 text-sm-h5 font-weight-medium rounded text-justify text-grey-darken-4"
                                                :style="
                                                    xs
                                                        ? 'line-height: 1.8rem !important'
                                                        : 'line-height: 2.4rem !important'
                                                "
                                            >
                                                <v-icon size="x-large">mdi-format-quote-open</v-icon>
                                                {{ tm.content }}
                                                <v-icon size="x-large">mdi-format-quote-close</v-icon>
                                            </div>
                                            <v-avatar
                                                :size="smAndDown ? 32 : 64"
                                                tile
                                                class="bg-grey-darken-4 rounded-circle elevation-2"
                                            >
                                                <v-img
                                                    :src="staticURLImg + tm.source"
                                                    :alt="tm.position + `logo`"
                                                ></v-img>
                                            </v-avatar>
                                            <span class="text-h5 font-weight-medium text-grey-darken-4">
                                                {{ tm.person }}
                                            </span>
                                            <span class="text-body-2 text-grey-darken-4">{{ tm.position }}</span>
                                            <span class="mb-16 text-caption text-grey-darken-4 font-weight-medium">{{
                                                tm.product
                                            }}</span>
                                        </div>
                                    </v-sheet>
                                </v-carousel-item>
                            </v-carousel>
                        </template>
                    </v-hover>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
